/*
 * Copyright (C) 2026 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {startSpan} from '@sentry/browser'
import i18next from '@canvas/i18next'
import bundleNamespaces from '@instructure/translations/lib/canvas-lms/bundle-namespaces.json'
// Generated by ui-build/webpack/generateHandlebarsNamespaces.js. Kept separate
// from the hand-maintained bundle-namespaces.json so regenerating it can't
// clobber manual entries. A Handlebars template renders once and never
// re-renders when a namespace lands late, so these must be awaited here.
import handlebarsNamespaces from '@instructure/translations/lib/canvas-lms/handlebars-namespaces.json'

const bundleNamespacesByBundle = bundleNamespaces as Record<string, string[]>
const handlebarsNamespacesByBundle = handlebarsNamespaces as Record<string, string[]>

export function preloadBundleNamespaces(bundle: string): Promise<void> {
  const namespaces = [
    ...new Set([
      ...(bundleNamespacesByBundle[bundle] ?? []),
      ...(handlebarsNamespacesByBundle[bundle] ?? []),
    ]),
  ]
  if (!namespaces.length) return Promise.resolve()

  return startSpan(
    {
      name: 'i18next.preloadBundleNamespaces',
      op: 'i18next.preload',
      data: {bundle, 'namespace.count': namespaces.length},
    },
    () => i18next.loadNamespaces(namespaces),
  )
}
